function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.3605 14.48H0.640488C0.286488 14.48 0.000488281 14.766 0.000488281 15.12V15.84C0.000488281 15.928 0.0724883 16 0.160488 16H15.8405C15.9285 16 16.0005 15.928 16.0005 15.84V15.12C16.0005 14.766 15.7145 14.48 15.3605 14.48ZM2.91449 12.8C2.95449 12.8 2.99449 12.796 3.03449 12.79L6.39849 12.2C6.43849 12.192 6.47649 12.174 6.50449 12.144L14.9825 3.666C15.001 3.6475 15.0157 3.62552 15.0258 3.60133C15.0358 3.57713 15.041 3.55119 15.041 3.525C15.041 3.49881 15.0358 3.47287 15.0258 3.44867C15.0157 3.42448 15.001 3.4025 14.9825 3.384L11.6585 0.058C11.6205 0.02 11.5705 0 11.5165 0C11.4625 0 11.4125 0.02 11.3745 0.058L2.89649 8.536C2.86649 8.566 2.84849 8.602 2.84049 8.642L2.25049 12.006C2.23103 12.1131 2.23798 12.2234 2.27074 12.3273C2.3035 12.4311 2.36108 12.5254 2.43849 12.602C2.57049 12.73 2.73649 12.8 2.91449 12.8Z",
  fill: "#94A1B2"
});

function SvgGhostPriceLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGhostPriceLogo);
export default __webpack_public_path__ + "static/media/ghostPriceLogo.0b455ce4f3a33058b713931924ac367d.svg";
export { ForwardRef as ReactComponent };